export default {
  mfaStatus: {
    available: 'available',
    unavailable: 'unavailable',
    not_configured: 'not_configured',
  },

  mfaNames: {
    duo: 'duo',
    durt: 'durt',
    durt_uv: 'durt_uv',
    sms_otp: 'sms_otp',
    push: 'push',
    totp: 'totp',
    webauthn: 'webauthn',
  },

  /**
   * On the initial MFA picker (no factor selected yet), factors in this list are shown only after
   * "Choose A Different Way" unless that factor was stored as previousMfaMethod (SMS last-used UX).
   */
  mfaChooserDeferredBackupNames: [
    'sms_otp',
  ],
};
